import { Component, Children, Fragment } from 'react';
import ErrorBoundaryWrapper from './ErrorBoundaryWrapper';

interface Props {
  readonly children: React.ReactNode;
}

export default class ErrorBoundaryWrapChildren extends Component<Props> {
  /**
   *
   */
  public render() {
    const wrapped = Children.map(this.props.children, child => <ErrorBoundaryWrapper component={child} />);
    return <Fragment>{wrapped}</Fragment>;
  }
}
